var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var XCircle = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.99996 10C1.99996 5.58172 5.58169 2 9.99996 2C14.4182 2 18 5.58172 18 10C18 14.4183 14.4182 18 9.99996 18C5.58169 18 1.99996 14.4183 1.99996 10ZM9.99996 0C4.47712 0 -3.62396e-05 4.47715 -3.62396e-05 10C-3.62396e-05 15.5228 4.47712 20 9.99996 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 9.99996 0ZM5.79286 5.79289C6.18338 5.40237 6.81655 5.40237 7.20707 5.79289L9.99996 8.58579L12.7929 5.79289C13.1834 5.40237 13.8165 5.40237 14.2071 5.79289C14.5976 6.18342 14.5976 6.81658 14.2071 7.20711L11.4142 10L14.2071 12.7929C14.5976 13.1834 14.5976 13.8166 14.2071 14.2071C13.8165 14.5976 13.1834 14.5976 12.7929 14.2071L9.99996 11.4142L7.20707 14.2071C6.81655 14.5976 6.18338 14.5976 5.79286 14.2071C5.40233 13.8166 5.40233 13.1834 5.79286 12.7929L8.58575 10L5.79286 7.20711C5.40233 6.81658 5.40233 6.18342 5.79286 5.79289Z", fill: "#F0FFFB" }) })));
};
